import React from "react";
import styles from "./uni_campus.module.scss";
import { htmlParse } from "@unisearch/helpers/utils";

const UniCampus = ({ email, phone, address, website, map }) => {
  return (
    <div className={styles.campus_info}>
      <div className={styles.left}>
        <div className="from_texteditor_wrapper">
          <table>
            <tbody>
              <tr>
                <td>Email</td>
                <td>{email ?? ""}</td>
              </tr>
              <tr>
                <td>Phone</td>
                <td>{phone ?? ""}</td>
              </tr>
              <tr>
                <td>Address</td>
                <td>{address ?? ""}</td>
              </tr>
              <tr>
                <td>Website</td>
                <td>{website ?? ""}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className={styles.right}>
        <div className={styles.map_wrapper}>{htmlParse(map)}</div>
      </div>
    </div>
  );
};

export default UniCampus;
